import { utils as utilsCore } from '@industriousapps/excelkits-core';
import createApiError from '@/utils/api/createError';
import account from '@/services/auth/account';
const PREFIX = 'common: services: googleDrive:';
const EXPORTED_MEME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const API_KEY = process.env.NEXT_PUBLIC_FIREBASE_API_KEY;
const API_DOMAIN = process.env.NEXT_PUBLIC_FIREBASE_FUNCTIONS_DOMAIN;
const generateSubscribeFileError = createApiError(`${PREFIX} subscribeFileRequest:`);
const generateUnsubscribeFileError = createApiError(`${PREFIX} unsubscribeFileRequest:`);
const {
  createWrappedError
} = utilsCore;
export const getFileRequest = async _ref => {
  let {
    fileId,
    fileMimeType,
    accessToken
  } = _ref;
  let url;

  if (!accessToken) {
    throw Error(`${PREFIX} getFileRequest: invalid access token provided`);
  } // Lookup appropriate google drive URL for meme type


  if (fileMimeType === 'application/vnd.google-apps.spreadsheet') {
    url = `https://content.googleapis.com/drive/v3/files/${fileId}/export?mimeType=${EXPORTED_MEME_TYPE}&alt=media&key=${API_KEY}`;
  } else if (fileMimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
  } else {
    throw Error(`${PREFIX} getFileRequest: Unknown file type: ${fileMimeType}`);
  } // Fetch file blob from Google Drive


  let response;

  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
  } catch (err) {
    throw createWrappedError(`${PREFIX} getFileRequest: unknown request failure`, err);
  } // Throw with known error


  if (!response.ok) {
    try {
      const {
        error
      } = await response.json();
      throw Error(error);
    } catch (err) {
      throw createWrappedError(`${PREFIX} subscribeFileRequest: request failed with status ${response.status}`, err);
    }
  }

  return await response.blob();
}; // Subscribe workbook to external changes

export const subscribeFileRequest = async _ref2 => {
  let {
    workbookId
  } = _ref2;
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (tokenErr) {
    throw Error(`${PREFIX} subscribeFileRequest: auth token could not be recovered: ${tokenErr}`);
  }

  let response;

  try {
    response = await fetch(`${API_DOMAIN}/api/v0/workbooks/${workbookId}/subscribe`, {
      method: 'GET',
      headers: {
        Authorization: `FB-JWT ${authToken}`,
        'Content-Type': 'application/json'
      }
    });
  } catch (err) {
    throw createWrappedError(`${PREFIX} subscribeFileRequest: unknown request failure`, err);
  }

  let responseJson = {};

  try {
    responseJson = await response.json();
  } catch (err) {
    throw createWrappedError(`${PREFIX} subscribeFileRequest: failed to parse JSON`, err);
  } // Throw unsuccessful request API error


  const apiError = generateSubscribeFileError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }
}; // Unsubscribe workbook from external changes

export const unSubscribeFileRequest = async _ref3 => {
  let {
    workbookId
  } = _ref3;
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (tokenErr) {
    throw Error(`${PREFIX} unsubscribeFileRequest: auth token could not be recovered: ${tokenErr}`);
  }

  let response;

  try {
    response = await fetch(`${API_DOMAIN}/api/v0/workbooks/${workbookId}/unsubscribe`, {
      method: 'GET',
      headers: {
        Authorization: `FB-JWT ${authToken}`,
        'Content-Type': 'application/json'
      }
    });
  } catch (err) {
    throw createWrappedError(`${PREFIX} unsubscribeFileRequest: unknown request failure`, err);
  }

  let responseJson = {};

  try {
    responseJson = await response.json();
  } catch (err) {
    throw createWrappedError(`${PREFIX} unSubscribeFileRequest: failed to parse JSON`, err);
  } // Throw unsuccessful request API error


  const apiError = generateUnsubscribeFileError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }

  return responseJson;
};